export default __webpack_public_path__ + "static/media/develop1.505d82bc.png";